import { UOMS, UomTypes } from '@amzn/awscat-portfolio-assessment-types';
import { RadioGroupProps } from '@amzn/awsui-components-react';

import { constants } from '../../../../common/Localization';
import { DEFAULT_DATABASE_UOM, uomConversion } from '../../../../common/uomConversion';
const UOM_OPTIONS = {
    frequency: [
        {
            label: UOMS.GHz,
            value: UOMS.GHz,
        },
        {
            label: UOMS.MHz,
            value: UOMS.MHz,
        },
        {
            label: UOMS.KHz,
            value: UOMS.KHz,
        },
        {
            label: UOMS.Hz,
            value: UOMS.Hz,
        },
    ],
    percentage: [
        {
            label: constants.PERCENTAGE_LABEL,
            value: UOMS.PERCENTAGE,
        },
        {
            label: constants.DECIMAL_LABEL,
            value: UOMS.DECIMAL,
        },
    ],
    storage: [
        {
            label: UOMS.TB,
            value: UOMS.TB,
        },
        {
            label: UOMS.GB,
            value: UOMS.GB,
        },
        {
            label: UOMS.MB,
            value: UOMS.MB,
        },
        {
            label: UOMS.KB,
            value: UOMS.KB,
        },
        {
            label: UOMS.BYTE,
            value: UOMS.BYTE,
        },
    ],
};

export function getUomOptions(uomType: UomTypes | undefined): RadioGroupProps.RadioButtonDefinition[] | null {
    switch (uomType) {
        case UomTypes.PERCENTAGE:
            return UOM_OPTIONS.percentage;
        case UomTypes.STORAGE:
            return UOM_OPTIONS.storage;
        case UomTypes.FREQUENCY:
            return UOM_OPTIONS.frequency;
    }
    return null;
}

export enum SizeConversionMode {
    binary = 'binary',
    decimal = 'decimal',
}

/**
 * Convert input value from given unit to DB unit
 * @param inputValue
 * @param fromUnit
 */
export function convertToDBUOM(inputValue: number, fromUnit: UOMS | undefined): number {
    if (isNaN(inputValue) || !fromUnit) { return inputValue; }

    let value = Number(inputValue);

    switch (fromUnit) {
        case UOMS.PERCENTAGE:
            value = uomConversion(value, fromUnit, DEFAULT_DATABASE_UOM[UomTypes.PERCENTAGE]);
            break;
        case UOMS.TB:
        case UOMS.GB:
        case UOMS.MB:
        case UOMS.BYTE:
            value = Math.ceil(uomConversion(value, fromUnit, DEFAULT_DATABASE_UOM[UomTypes.STORAGE]));
            break;
        case UOMS.Hz:
        case UOMS.KHz:
        case UOMS.MHz:
            value = uomConversion(value, fromUnit, DEFAULT_DATABASE_UOM[UomTypes.FREQUENCY]);
            break;
        case UOMS.GHz:
        case UOMS.KB:
        case UOMS.DECIMAL:
            break;
    }
    return value;
}
